import { render } from "./YourJourneyDropdown.vue?vue&type=template&id=f04b185e&scoped=true"
import script from "./YourJourneyDropdown.vue?vue&type=script&lang=js"
export * from "./YourJourneyDropdown.vue?vue&type=script&lang=js"

import "./YourJourneyDropdown.vue?vue&type=style&index=0&id=f04b185e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04b185e"]])

export default __exports__